import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/components/ui/command";
import { Home, Users, FileText, Settings, Search, Plus, Table2 } from "lucide-react";

interface CommandPaletteProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function CommandPalette({ open, onOpenChange }: CommandPaletteProps) {
  const navigate = useNavigate();

  const runCommand = (command: () => void) => {
    onOpenChange(false);
    command();
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Digite um comando ou busque..." />
      <CommandList>
        <CommandEmpty>Nenhum resultado encontrado.</CommandEmpty>
        
        <CommandGroup heading="Navegação">
          <CommandItem onSelect={() => runCommand(() => navigate("/admin"))}>
            <Home className="mr-2 h-4 w-4" />
            <span>Dashboard</span>
            <kbd className="ml-auto pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">
              <span className="text-xs">g</span>
              <span className="text-xs">h</span>
            </kbd>
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => navigate("/admin/cadastros/profissionais"))}>
            <Users className="mr-2 h-4 w-4" />
            <span>Profissionais</span>
            <kbd className="ml-auto pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">
              <span className="text-xs">g</span>
              <span className="text-xs">p</span>
            </kbd>
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => navigate("/admin/cadastros/pacientes"))}>
            <FileText className="mr-2 h-4 w-4" />
            <span>Pacientes</span>
            <kbd className="ml-auto pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">
              <span className="text-xs">g</span>
              <span className="text-xs">u</span>
            </kbd>
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => navigate("/admin/tabelas-preco"))}>
            <Table2 className="mr-2 h-4 w-4" />
            <span>Tabelas de Preço</span>
          </CommandItem>
          <CommandItem onSelect={() => runCommand(() => navigate("/admin/configuracoes"))}>
            <Settings className="mr-2 h-4 w-4" />
            <span>Configurações</span>
            <kbd className="ml-auto pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium text-muted-foreground">
              <span className="text-xs">g</span>
              <span className="text-xs">c</span>
            </kbd>
          </CommandItem>
        </CommandGroup>
        
        <CommandSeparator />
        
        <CommandGroup heading="Ações">
          <CommandItem>
            <Plus className="mr-2 h-4 w-4" />
            <span>Novo Profissional</span>
          </CommandItem>
          <CommandItem>
            <Search className="mr-2 h-4 w-4" />
            <span>Buscar Paciente</span>
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
